import { render, staticRenderFns } from "./MyDiscuss.vue?vue&type=template&id=9cfbaffc&"
import script from "./MyDiscuss.vue?vue&type=script&lang=js&"
export * from "./MyDiscuss.vue?vue&type=script&lang=js&"
import style0 from "./MyDiscuss.vue?vue&type=style&index=0&id=9cfbaffc&prod&lang=less&sopced=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports